import { createFileRoute } from '@tanstack/react-router';

import { ResetPasswordPage } from '~/components/auth/reset-password-page.tsx';

function validateAuthSearch(search: Record<string, unknown>) {
	return {
		redirectTo: typeof search.redirectTo === 'string' ? search.redirectTo : undefined,
	};
}

export const Route = createFileRoute('/auth/reset-password')({
	component: AuthResetPasswordPage,
	validateSearch: validateAuthSearch,
});

function AuthResetPasswordPage() {
	const { redirectTo } = Route.useSearch();

	return <ResetPasswordPage redirectTo={redirectTo} />;
}
